import React from "react";
import Box from "@mui/material/Box";
const LoadingDots = ({ loaderText }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        ml: "auto",
        mr: "auto",
      }}
    >
      <div className="loading">{loaderText}</div>
    </Box>
  );
};

export default LoadingDots;
